import { useServerTranslation } from 'hooks/useServerTranslation';
import { z } from 'zod';

export function useMaxCharacters() {
    const { t } = useServerTranslation();

    return (string: z.ZodString, max?: number) => {
        if (max) {
            const message = t('form-errors.max-characters', { max });

            return string.max(max, { message });
        }

        return string;
    };
}
